(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gulf-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('luna-review-carousel')){
 customElements.define('luna-review-carousel',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const track=this.querySelector('.luna-review-carousel__track'),cards=[...track.children],toggle=this.querySelector('[data-review-toggle]');
   const reduce=matchMedia('(prefers-reduced-motion: reduce)');
   let stopped=reduce.matches,hover=false,focused=false,index=0;
   const sync=()=>{toggle.textContent=stopped?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-pressed',String(stopped));};
   const move=delta=>{const end=Math.abs(track.scrollLeft)>=track.scrollWidth-track.clientWidth-3;index=delta>0&&end?0:(index+delta+cards.length)%cards.length;const a=cards[index].getBoundingClientRect(),b=track.getBoundingClientRect();const rtl=getComputedStyle(track).direction==='rtl';track.scrollBy({left:rtl?a.right-b.right:a.left-b.left,behavior:reduce.matches?'instant':'smooth'});};
   toggle.addEventListener('click',()=>{stopped=!stopped;sync();});
   this.querySelector('[data-review-next]').addEventListener('click',()=>{stopped=true;sync();move(1);});
   this.querySelector('[data-review-prev]').addEventListener('click',()=>{stopped=true;sync();move(-1);});
   this.addEventListener('mouseenter',()=>hover=true);this.addEventListener('mouseleave',()=>hover=false);
   this.addEventListener('focusin',()=>focused=true);this.addEventListener('focusout',e=>focused=this.contains(e.relatedTarget));
   track.addEventListener('pointerdown',()=>{stopped=true;sync();});
   track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();stopped=true;sync();move(e.key==='ArrowLeft'?1:-1);}});
   track.addEventListener('scroll',()=>{const b=track.getBoundingClientRect(),rtl=getComputedStyle(track).direction==='rtl';let min=Infinity;cards.forEach((c,i)=>{const a=c.getBoundingClientRect(),d=Math.abs(rtl?a.right-b.right:a.left-b.left);if(d<min){min=d;index=i;}});},{passive:true});
   this.timer=setInterval(()=>{if(!stopped&&!hover&&!focused&&!document.hidden){const r=track.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0)move(1);}},6500);sync();
  }
  disconnectedCallback(){clearInterval(this.timer);this.ready=false;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
